import React from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import { CustomText } from "../../../../../components/text/Text";
import { windowWidth } from "../../../../../constants";
import SVG from "../../../../../imports/svg";

const FeedbackItem = ({ isSelected = false}) => {
    
    return (
        <TouchableOpacity style={ isSelected ? styles.selectedContainer : styles.container}>
            <View style={ isSelected ? styles.selectedBoxContainer :styles.checkBoxContainer}>
              <SVG name={'whitecheck'} width={10} height={10}/>
            </View>
            <View>
                <CustomText size={16} font={'700'}>
                    {'قیمت بالای کرایه ها'}
                </CustomText>
                <CustomText mt={8} size={13} font={'400'}>
                    {'قیمت کرایه های وسیله ها برایم زیاد است'}
                </CustomText>

            </View>
        </TouchableOpacity>
    )
}

export default FeedbackItem

const styles = StyleSheet.create({
    selectedContainer : {
        width: windowWidth - 32,
        height: 73,
        borderWidth : 1 , 
        marginBottom : 12 , 
        borderColor : '#EAEAEA' , 
        flexDirection  :'row' , 
        justifyContent  :'space-between' ,
        borderColor  :'#F78B83' , 
        borderWidth : 2 , 
        alignItems : 'center' , 
        borderRadius : 18 , 
        alignSelf : 'stretch' , 
        padding : 12  ,
    },  
    selectedBoxContainer : {
        backgroundColor : '#F34F42' ,
        width : 20 , 
        height : 20 , 
        justifyContent :'center' , 
        alignItems : 'center' , 
        borderColor : '#CFCFCF' , 
        borderRadius : 2 ,  
    },  
    container: {
        width: windowWidth - 32,
        marginBottom : 12 , 
        height: 73,
        borderWidth : 1 , 
        borderColor : '#EAEAEA' , 
        flexDirection  :'row' , 
        justifyContent  :'space-between' ,
        alignItems : 'center' , 
        borderRadius : 18 , 
        alignSelf : 'stretch' , 
        padding : 12  ,
    },
    checkBoxContainer : {
            width : 20 , 
            height : 20 , 
            justifyContent :'center' , 
            alignItems : 'center' , 
            borderWidth : 2 ,
            borderColor : '#CFCFCF' , 
            borderRadius : 2 ,  
    }


})